import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';

import { useCheckoutContext } from '../../state/CheckoutContext';

import Card from '../shared/Card';
import Inset from '../shared/Inset';
import DurationSelectSideBySide from './DurationSelectSideBySide';
import PricingList from './PricingList';
import SubscriptionFeatures from '../shared/SubscriptionFeatures';
import Footer from './Footer';
import { getStyles as _getStyles } from '../../utils/checkoutUtils.js';

import styles from './Summary.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';
export const I18nPrefixTrial = 'strava.subscriptions.checkout.summary.trial';
export const I18nPrefixSubscriptionPreview =
  'components.subscription_preview.checkout';

export const Summary = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const {
    duration,
    experiments,
    promoCampaign,
    pricing,
    products
  } = checkoutEntityState;
  const promotionArgument = products?.promotion?.argument;
  const { recurringAmount, billedToday, currency } = pricing;
  const {
    shouldShowSubscriptionPreview,
    shouldShowCheckoutRefresh
  } = experiments;

  const shouldShowSubscriptionFeatures =
    shouldShowSubscriptionPreview || shouldShowCheckoutRefresh;
  const shouldShowMembershipHeader =
    promoCampaign && !shouldShowCheckoutRefresh;
  const title = shouldShowSubscriptionPreview
    ? I18n.t(`${I18nPrefixSubscriptionPreview}.title`)
    : I18n.t(`${I18nPrefix}.title`);

  const getStyles = (style) =>
    _getStyles(styles, style, shouldShowCheckoutRefresh);

  return (
    <div className={styles.checkoutSummary}>
      <Card className={clsx(getStyles('card'))}>
        {shouldShowSubscriptionFeatures && (
          <Inset className={clsx(getStyles('overviewSection'))}>
            <h4 className={clsx(getStyles('overviewTitle'))}>{title}</h4>
            <p className={styles.overviewDescription}>
              <SubscriptionFeatures />
            </p>
          </Inset>
        )}
        {shouldShowMembershipHeader ? (
          <Inset>
            <h4 className={styles.promoHeader} data-testid="promo-header">
              {I18n.t(`${I18nPrefix}.membership.${duration}`)}
            </h4>
          </Inset>
        ) : (
          <Inset dataTestId="duration-select">
            <DurationSelectSideBySide />
          </Inset>
        )}
        <PricingList />

        <Inset className={clsx(getStyles('summaryFooter'))}>
          <Footer />
        </Inset>

        {!shouldShowCheckoutRefresh && (
          <Inset className={styles.footnote}>
            {recurringAmount !== billedToday &&
              I18n.t(`${I18nPrefix}.price_after_discount_v2.${duration}`, {
                price: Cldr.formatCurrency(recurringAmount, currency),
                count: promotionArgument
              })}{' '}
            {I18n.t(`${I18nPrefix}.cancel`)}
          </Inset>
        )}
      </Card>
    </div>
  );
};

export default Summary;
